import React, { Component } from "react";

class WorkerJobs extends Component {
  render() {
    return <div>You don't have access.</div>;
  }
}

export default WorkerJobs;
